jQuery( document ).ready( function($){
	
	if( typeof current_collection_url != 'undefined' ) {
	
		var want_to_remove = "https://"+$('<a>').prop('href', window.location.href).prop('hostname')+current_collection_url+"/";
		
		var current_url = window.location.href;
		
		var final_url = current_url.replace(want_to_remove,'');
		
		var current_tags = final_url.split("+");
		
		current_tags.forEach(function(item) { 
			
			$( '.collection_ratio_filter .ratio_filter[data-ratio="'+ item +'"]' ).prop('checked', true);
			
		});
		
		$( '.collection_ratio_filter .ratio_filter' ).change( function(){
			
			var ratio_id = '';
			
			$.each($( '.collection_ratio_filter .ratio_filter:checked' ), function(){ 
					
				   ratio_id += $(this).data('ratio')+"+";
					
			});
			
			
			window.location.href = current_collection_url+"/"+(ratio_id).slice(0,-1);
			
		})
	
	}
	
});